import { ActionType } from "../actions/actionTypes";

type ProductState = {
  products: Product[];
  states: CodeRef[];
  carrierGroups: CarrierGroup[];
  codeRefs?: { [key: string]: CodeRef[] };
};

const INITIAL_STATE = {
  products: [],
  states: [],
  carrierGroups: []
};

export default (
  state: ProductState = INITIAL_STATE,
  action: ActionType
): ProductState => {
  switch (action.type) {
    case "FETCH_PRODUCTS_FOR_DATE_SUCCESS": {
      return { ...state, ...action.payload };
    }
    case "FETCH_PRODUCT_CODE_REFS_SUCCESS": {
      return { ...state, codeRefs: { ...state.codeRefs, ...action.payload } };
    }
    default:
      return state;
  }
};
